"use strict";

exports.__esModule = true;
exports["default"] = void 0;

/**
 * Smooth scrolling onClick event handler
 * @param {string} selector argument will be passed to `querySelector`, usually an HTML id
 */
var scrollTo = function scrollTo(selector) {
  document.querySelector(selector).scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
};

var _default = scrollTo;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-smoothscroll/index.js
// module id = 139
// module chunks = 28313394369846 114276838955818